/**
 * Shared theming primitives for the Insights tab. Recharts charts pull
 * their palette and tooltip presentation from here so the look stays
 * harmonized with the lightweight-charts scrub charts.
 */

/**
 * Muted, harmonized palette for category-coded slices and lines. Picked
 * to read clearly against both light and dark surfaces and to sit next
 * to the brand green (#0EA66B) without competing with it.
 */
export const CHART_PALETTE = [
  '#0EA66B', // muted green
  '#5B7CFA', // muted blue
  '#E8B339', // muted amber
  '#A855F7', // violet
  '#0EA5A6', // teal
  '#E5484D', // muted red
  '#F472B6', // pink
  '#71717A', // zinc
] as const;
